<template>
  <div class="create-system">
    <div class="breadcrumb" style="background: #fff">创建SKU组</div>
    <div class="third-title">SKU组属性</div>
    <div class="order-detail-basic">
      <el-form :model="skuVo" :rules="addRules" ref="addForm" label-width="130px" hide-required-asterisk>
        <el-form-item label="SKU组名称:" prop="skuGroupName">
          <el-input v-model="skuVo.skuGroupName"></el-input>
        </el-form-item>
        <el-form-item label="SKU组图片:" prop="skuGroupImage">
          <div class="upload-img">
            <input type="file" name="" id="input_img" @change="fileSize($event)" />
            <el-button round>上传图片</el-button>
          </div>
          <div id="show_img" style="width: 100%;" v-if="skuVo.skuGroupImage">
            <img :src="skuVo.skuGroupImage" alt="" style="max-width: 200px;float: left">
          </div>
        </el-form-item>
        <div class="third-title" style="margin-left: 0;margin-bottom: 20px;">SKU组属性</div>
        <el-form-item id="aaadd" label="选择产品:">
          <el-cascader :show-all-levels="false" v-model="categoryId" @change="getSpuList" :props="props"></el-cascader>
          <el-select v-model="selectSpuId" v-show="categoryId !== null" placeholder="请选择" @change="getSpuMsg">
            <el-option v-for="item in spuList" :key="item.id" :value="item.id" :label="item.spuName" style="height: auto"> </el-option>
          </el-select>
          <!-- <el-button type="primary" v-show="selectSpuId!==''" @click="getSpuMsg" style="margin-left:20px" round>确定</el-button> -->
        </el-form-item>
        <el-form-item label="选择SKU:">
          <el-select v-model="skuList.skuGroup" v-if="$route.query.spuProperty !== 'NORMAL'" value-key="id" @change="getSkuListBySkuGroupId" placeholder="请选择">
            <el-option v-for="item in skuGroupListBySpuId" :key="item.id" :label="item.skuGroupName" :value="item" style="height: auto"></el-option>
          </el-select>
          <el-table :data="skuGroupListBySpuId" v-if="$route.query.spuProperty === 'NORMAL'" border :row-class-name="RowClassName">
            <el-table-column label="SKU组名称" min-width="100px" prop="skuGroupName"></el-table-column>
            <el-table-column label="SKU组图片" min-width="100px">
              <template slot-scope="scope">
                <img style="max-width:100px" :src="scope.row.skuGroupImage" alt="">
              </template>
            </el-table-column>
            <el-table-column label="属性组合" min-width="100px" prop="attr">
              <template slot-scope="scope">{{ scope.row.dictSet }}</template>
            </el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template v-slot="scope"><span class="color-blue" @click="CURRENCYAddSkuGroup(scope.row)">添加</span></template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-table :data="tableData" border :row-class-name="RowClassName">
            <el-table-column label="SKU名称" min-width="100px" prop="skuName"></el-table-column>
            <el-table-column label="SKU前端显示名称" min-width="100px" prop="skuFrontName"></el-table-column>
            <el-table-column label="SKU组名称" min-width="100px" prop="skuGName">
              <template>{{ skuList.skuGroup.skuGroupName }}</template>
            </el-table-column>
            <el-table-column label="SKU组图片" min-width="100px">
              <template>
                <img style="max-width:100px" :src="skuList.skuGroup.skuGroupImage" alt="">
              </template>
            </el-table-column>
            <el-table-column label="属性组合" min-width="100px" prop="attr">
              <template>{{ skuList.skuGroup.dictSet }}</template>
            </el-table-column>
            <el-table-column label="尺寸" min-width="100px" prop="attr">
              <template slot-scope="scope">
                <span @click="checkSizeGroup(scope.row)" class="color-blue">查看尺寸组</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template v-slot="scope"><span class="color-blue" @click="addSKUGroup(scope.row)">添加</span></template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="套系内SKU组组合:" v-if="$route.query.spuProperty === 'NORMAL'" prop="skuGroupTags">
          <el-tag v-for="(tag, index) in skuGroupTags" :key="tag.skuGroupName + index" closable :disable-transitions="false" @close="skuGroupTags.splice(index, 1)" type="info"> {{ tag.skuGroupName }}
          </el-tag>
        </el-form-item>
        <el-form-item label="套系内SKU组合:" v-if="$route.query.spuProperty !== 'NORMAL'" prop="skuGroupTags">
          <el-tag v-for="(tag, index) in tags" :key="tag.skuName + index" closable :disable-transitions="false" @close="deleteSKUGroup(index)" type="info"> {{ tag.skuName }}</el-tag>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item label="基础P平台价格:" prop="simpleSkuSeriesVo.basePagePrice">
            <el-input v-model="skuVo.simpleSkuSeriesVo.basePagePrice" @input="changeBasePagePrice" @mousewheel.native.prevent></el-input>
          </el-form-item>
          <el-form-item label="基础P积分价格:" prop="simpleSkuSeriesVo.basePagePoints" v-if="$route.query.showPoint == 'true'">
            <el-input v-model="skuVo.simpleSkuSeriesVo.basePagePoints" @input="changeBasePagePoints" @mousewheel.native.prevent></el-input>
          </el-form-item>
        </div>
        <el-form-item label="在线支付价格:" prop="simpleSkuSeriesVo.onlineSalePrice" v-if="$route.query.showPoint != 'true'">
          <el-input v-model="skuVo.simpleSkuSeriesVo.onlineSalePrice" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <el-form-item label="推荐终端价格:" prop="simpleSkuSeriesVo.salePrice">
          <el-input v-model="skuVo.simpleSkuSeriesVo.salePrice" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <el-form-item label="初创平台价格:" prop="simpleSkuSeriesVo.startupsBasePagePrice" v-if="$route.query.startupsSpu == 'true'">
          <el-input v-model="skuVo.simpleSkuSeriesVo.startupsBasePagePrice" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <!-- <el-form-item label="批量数量:" prop="simpleSkuSeriesVo.salePrice">
          <el-input v-model="skuVo.simpleSkuSeriesVo.salePrice" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <el-form-item label="批量价格:" prop="simpleSkuSeriesVo.salePrice">
          <el-input v-model="skuVo.simpleSkuSeriesVo.salePrice" @mousewheel.native.prevent></el-input>
        </el-form-item> -->
        <el-form-item label="通货编码:" v-if="$route.query.spuProperty === 'NORMAL'" prop="simpleSkuSeriesVo.sampleBarCode">
          <el-input v-model="skuVo.simpleSkuSeriesVo.sampleBarCode" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <el-form-item label="样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'" prop="samplePrice">
          <el-input v-model="skuVo.samplePrice" @input="changeSamplePrice" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <el-form-item label="样品积分价格:" v-if="$route.query.spuProperty !== 'NORMAL' && $route.query.showPoint == 'true'" prop="samplePoints">
          <el-input v-model="skuVo.samplePoints" @input="changeSamplePoints" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <el-form-item label="在线样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'" prop="onlineSamplePrice">
          <el-input v-model="skuVo.onlineSamplePrice" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <!-- 新加的 -->
        <el-form-item label="初创平台样品价格:" v-if="$route.query.spuProperty !== 'NORMAL' && $route.query.startupsSpu == 'true'" prop="startupsSamplePrice">
          <el-input v-model="skuVo.startupsSamplePrice" @mousewheel.native.prevent></el-input>
        </el-form-item>
        <el-form-item label="样品主题:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-select value-key='id' v-model="skuTransferMsg.sampleItem" placeholder="请选择" class="mr-10">
            <el-option :label="item.themeName" :value="item" v-for="item in skuTransferMsg.sampleList" :key="item.id"></el-option>
          </el-select>
          <el-button round @click="appendSampleTheme">添加</el-button>
        </el-form-item>
        <el-form-item label="" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-table :data="this.skuVo.sampleThemeList" style="width: 500px" border>
            <!-- <el-table-column label="样品编码" min-width="180px" prop="sampleBarCode">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sampleBarCode"></el-input>
              </template>
            </el-table-column> -->
            <el-table-column label="主题" min-width="100px" prop="themeName"></el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template v-slot="scope">
                <span class="color-blue" @click="deleteSampleTheme(scope)">删除</span>
                <!-- 这里创建的时候没法上传，现在后端的逻辑是上传的时候绑定到sku组上，但是这里创建的时候还没生成sku组，没法绑定 -->
                <!-- <span @click="upLoadTheme(scope.row.id, scope.$index)" class="color-blue" style="margin-left: 10px;">上传</span>
                <span @click="(scope.row.isUploaded || scope.row.skuGroupSampleImageList.length > 0) ? previewImg(scope.row.id, scope.$index) : ''"
                  :class="(scope.row.isUploaded || scope.row.skuGroupSampleImageList.length > 0) ? 'color-blue' : ''" style="margin-left: 10px;">预览</span> -->
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <!-- <el-button round @click="returnPage">上一步</el-button> -->
      <el-button round @click="createSku" type="primary">创建SKU组</el-button>
    </div>
    <!-- 查看尺寸组 -->
    <el-dialog :close-on-click-modal="false" width="800px" title="尺寸组" :visible.sync="sizeGroupDialog">
      <el-table :data="checkSizeGroupTableData" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName"></el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上：{{ scope.row.bleed.bleedTop }}mm 底部：{{ scope.row.bleed.bleedBottom }}mm<br> 内侧：{{ scope.row.bleed.bleedIn }}mm 外侧：{{ scope.row.bleed.bleedOut }}mm
                  </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId"></el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="pageName" min-width="100px"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 上传样品文件 -->
    <el-dialog :close-on-click-modal="false" title="上传文件" :visible.sync="upLoadSampleTheme" @closed="closeSampleTheme" width="500px" v-if="upLoadSampleTheme">
      <el-form :inline="true" class="demo-form-inline" v-for="(item, index) in tagsList" :key="index">
        <el-form-item label="套系内sku:" style="width:100%">
          <span>{{ item.skuName }}<span v-show="item.basePage != item.maxPage">({{ item.basePage }}-{{ item.maxPage }}P)</span><span v-show="item.basePage == item.maxPage">({{ item.basePage
          }}P)</span></span>
        </el-form-item>
        <el-form-item label="上传样片文件:" style="width:100%">
          <!-- <el-upload ref="handleUpload" action="#" :http-request="unloadAccessory" :before-upload="handleBeforeUpload" :show-file-list="false" multiple>
            <el-button size="small" type="primary" @click="handleAddFolder">点击上传</el-button>
          </el-upload> -->
          <el-button size="small" type="primary" @click="handleAddFolder(index, item)">点击上传</el-button>
          <div class="el-upload__tip" v-if="!item.fileName">只能上传文件夹</div>
          <div class="el-upload__tip" v-else>已上传:{{ item.fileName }}</div>
        </el-form-item>
      </el-form>
      <input type="file" webkitdirectory @change="handleFiles" style="display: none" ref="fileInput" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addThemeFile" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 轮播（预览） -->
    <el-dialog :visible.sync="imgViewerVisible" width="60%" class="dialog" v-if="imgViewerVisible" :fullscreen="isFull" :showClose="false">
      <template slot="title">
        <div style="display:flex; justify-content:space-between;">
          <div>{{ itemImgs.name }}</div>
          <div style="display:flex;">
            <img src="../../../assets/images/page-big.png" width="18px" alt="" @click="isFull = true" v-if="!isFull" />
            <img src="../../../assets/images/page-small.png" width="18px" alt="" @click="isFull = false" v-else />
            <img src="../../../assets/images/close.png" width="18px" alt="" style="margin-left:20px;" @click="imgViewerVisible = false" />
          </div>
        </div>
      </template>
      <div style="text-align: center;width: 100%;">{{ itemImgs.index }}/{{ imageList.length }}</div>
      <div class="dialog-box">
        <div class="switch-btn" @click="onClickCarousel('prev')"><img src="../../../assets/images/carousel-left.png" width="30px" /></div>
        <el-carousel :interval="5000" arrow="never" class="switch-box" :indicator-position="'none'" ref="el-carousel" :loop="false" :autoplay="false" height="400px" @change="carouselChange">
          <!-- <el-carousel-item class="switch" v-if="!isOneLoad"><img :src="UserLookList[0].thumbnailUrl + '?x-sds-process=image/resize,l_160,m_mfit'" @load="changeLoad" />
              </el-carousel-item> -->
          <el-carousel-item v-for="(item, index) in imageList" :key="index" class="switch"><img :src="item.imageUrl" />
          </el-carousel-item>
        </el-carousel>
        <div class="switch-btn" @click="onClickCarousel('next')"><img src="../../../assets/images/carousel-right.png" width="30px" /></div>
      </div>
      <!-- <div class="dialog-btn"><p class="submit" @click="onSubmit" v-if="detailOrder.totalOprt === detailOrder.totalCustomer">确认</p> </div> -->
    </el-dialog>
  </div>
</template>
<script>
import ExifReader from 'exifreader'
import { findCloseNum } from '@/utils/transitionFile.js'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { sampleListNoPaging, composeGroupDetail, categoryList, queryAllSubs, skuGroupAddSeriesCurrency, spuList, openCategoryList, categoryQuerySub, skuGroupSeriesAdd, skuGroupListBySpuId, skuList, previewSampleImage, saveSampleImage } from '@/api/pms'
import SortLikeWin from '@/utils/sortFile.js'
import { getPointRules } from '@/api/crm'

export default {
  name: 'createSystemSKU',
  components: {
  },
  data () {
    var _this = this
    var checkBasePagePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入基础P价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('基础P价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入样品价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('样品价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkSamplePoints = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入样品积分价格'))
      } else if (!this.$reg.checkInteger.reg.test(value)) {
        callback(new Error('样品积分价格' + this.$reg.checkInteger.message))
      } else {
        callback()
      }
    }
    var onlineSamplePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入在线样品价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('在线样品价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var startupsSamplePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入在线样品价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('在线样品价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最低终端价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('最低终端价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var onlineSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入在线支付价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('在线支付价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var startupsBasePagePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入初创平台价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('初创平台价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkSkuGroupTags = (rule, value, callback) => {
      if (this.$route.query.spuProperty === 'NORMAL' && this.skuGroupTags.length === 0) {
        callback(new Error('请选择套系内SKU'))
      } else if (this.$route.query.spuProperty !== 'NORMAL' && this.tags.length === 0) {
        callback(new Error('请选择套系内SKU'))
      } else {
        callback()
      }
    }
    return {
      upLoadSampleTheme: false,
      imgViewerVisible: false,
      addRules: {
        skuGroupName: [
          { required: true, message: '请输入SKU组名称', trigger: 'blur' }
        ],
        skuGroupImage: [
          { required: true, message: '请上传SKU组图片', trigger: 'blur' }
        ],
        'simpleSkuSeriesVo.basePagePrice': [
          { validator: checkBasePagePrice, trigger: 'blur' }
        ],
        'simpleSkuSeriesVo.salePrice': [
          { validator: checkSalePrice, trigger: 'blur' }
        ],
        'simpleSkuSeriesVo.onlineSalePrice': [
          { validator: onlineSalePrice, trigger: 'blur' }
        ],
        'simpleSkuSeriesVo.startupsBasePagePrice': [
          { validator: startupsBasePagePrice, trigger: 'blur' }
        ],
        startupsSamplePrice: [
          { validator: startupsSamplePrice, trigger: 'blur' }
        ],
        samplePrice: [
          { validator: checkPrice, trigger: 'blur' }
        ],
        samplePoints: [
          { validator: checkPrice, trigger: 'blur' }
        ],
        onlineSamplePrice: [
          { validator: onlineSamplePrice, trigger: 'blur' }
        ],
        skuGroupTags: [
          { validator: checkSkuGroupTags }
        ]
      },
      categoryId: null,
      props: {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          const { level, value } = node
          if (level === 0) {
            categoryList(value).then(res => {
              let nodes = res.data.data.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.bottom || item.id === 4
                }
              })
              nodes = nodes.filter(item => {
                return item.value === +_this.$route.query.categoryId || item.label === '通用'
              })
              resolve(nodes)
            })
          } else if (level === 1) {
            queryAllSubs(value).then(res => {
              let nodes = res.data.data.subCategoryList.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.subCategoryList.length === 0,
                  subCategoryList: item.subCategoryList
                }
              })
              resolve(nodes)
            })
          } else {
            let nodes = node.data.subCategoryList.map(item => {
              return {
                value: item.id,
                label: item.categoryName,
                leaf: item.subCategoryList.length === 0,
                subCategoryList: item.subCategoryList
              }
            })
            resolve(nodes)
          }
        }
        // lazyLoad (node, resolve) {
        //   const { level, value } = node
        //   if (level === 0) {
        //     openCategoryList().then(res => {
        //       let nodes = res.data.data.map(item => {
        //         return {
        //           value: item.id,
        //           label: item.categoryName,
        //           leaf: item.bottom
        //         }
        //       })
        //       nodes = nodes.filter(item => {
        //         return item.value === +_this.$route.query.categoryId || item.label === '通用'
        //       })
        //       resolve(nodes)
        //     })
        //   } else {
        //     categoryQuerySub(value).then(res => {
        //       let nodes = res.data.data.map(item => {
        //         return {
        //           value: item.id,
        //           label: item.categoryName,
        //           leaf: item.bottom
        //         }
        //       })
        //       resolve(nodes)
        //     })
        //   }
        // }
      },
      awsSdk: null,
      selectSpuId: '',
      sizeGroupDialog: false,
      checkSizeGroupTableData: [],
      skuVo: {
        onlineSamplePrice: '',
        startupsSamplePrice: '',
        samplePrice: '',
        samplePoints: '',
        sampleThemeList: [],
        // sampleThemeIdSet: [],
        simpleSkuSeriesVo: {
          onlineSalePrice: '',
          startupsBasePagePrice: '',
          salePrice: '',
          sampleBarCode: '',
          basePagePrice: '',
          skuIdSet: [],
          terminalStepSalePrice: '',
          terminalSalePrice: ''
        },
        skuGroupImage: '',
        skuGroupName: '',
        spuId: +this.$route.query.spuId,
        isTimeLimit: false,
        stockCount: 5000
      },
      skuTransferMsg: {
        sampleItem: '',
        sampleList: [],
        sampleTableData: []
      },
      treeData: '',
      treeDataValue: '',
      skuList: {
        skuName: '',
        imgSrc: '',
        proType: '',
        product: '',
        skuGroup: '',
        skuSystem: [],
        price: '',
        onlineSamplePrice: '',
        startupsSamplePrice: '',
        samplePrice: '',
        theme: '',
        type: '',
        sampleTheme: '',
        addSampleTheme: []
      },
      options: [],
      tableData: [],
      tags: [],
      tagsList: [],
      skuGroupTags: [],
      spuQueryInfo: {
        pageNum: 1,
        pageSize: 100
      },
      spuList: [],
      skuGroupListBySpuId: [],
      basePagePointsEdited: false,
      samplePointsEdited: false,
      pointExchangeRote: 0
    }
  },
  created () {
    this.getSampleList()
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    if (this.$route.query.showPoint == 'true') {
      this.getUserPointExchangeRote()
    }
  },
  methods: {
    getUserPointExchangeRote () {
      getPointRules('WD').then(res => {
        if (res.data.success) {
          this.pointExchangeRote = res.data.data.exchangeRate
        }
      })
    },
    changeBasePagePrice () {
      console.log('changeBasePagePrice111')
      if (this.basePagePointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuVo.simpleSkuSeriesVo.basePagePoints = Math.ceil(this.skuVo.simpleSkuSeriesVo.basePagePrice * this.pointExchangeRote)
      this.$forceUpdate()
    },
    changeBasePagePoints () {
      this.basePagePointsEdited = true
      this.$forceUpdate()
    },

    changeSamplePrice () {
      console.log('changeBasePagePrice111')
      if (this.samplePointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuVo.samplePoints = Math.ceil(this.skuVo.samplePrice * this.pointExchangeRote)
      this.$forceUpdate()
    },
    changeSamplePoints () {
      this.samplePointsEdited = true
      this.$forceUpdate()
    },
    CURRENCYAddSkuGroup (row) {
      let lock = true
      this.skuGroupTags.forEach(item => {
        if (item.id === row.id) {
          lock = false
        }
      })
      if (lock) {
        skuList(row.id).then(res => {
          if (res.data.success) {
            row.skuList = res.data.data
            this.skuGroupTags.push(row)
          }
        })
      }
    },
    // 创建新SKU组
    createSku () {
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.$route.query.spuProperty === 'NORMAL') {
          let addSeriesCurrencySkuGroupVO = {
            price: this.skuVo.simpleSkuSeriesVo.basePagePrice,
            basePagePoints: this.skuVo.simpleSkuSeriesVo.basePagePoints,
            salePrice: this.skuVo.simpleSkuSeriesVo.salePrice,
            sampleBarCode: this.skuVo.simpleSkuSeriesVo.sampleBarCode,
            onlineSalePrice: this.$route.query.showPoint == 'true' ? this.skuVo.simpleSkuSeriesVo.basePagePrice : this.skuVo.simpleSkuSeriesVo.onlineSalePrice,
            startupsBasePagePrice: this.skuVo.simpleSkuSeriesVo.startupsBasePagePrice,
            terminalSalePrice: this.skuVo.simpleSkuSeriesVo.salePrice,
            terminalStepSalePrice: this.skuVo.simpleSkuSeriesVo.salePrice,
            skuGroupImage: this.skuVo.skuGroupImage,
            skuGroupName: this.skuVo.skuGroupName,
            skuIds: [],
            skuName: this.skuVo.skuGroupName,
            spuId: this.$route.query.spuId,
            isTimeLimit: false,
            stockCount: 5000
          }
          this.skuGroupTags.forEach(item => {
            addSeriesCurrencySkuGroupVO.skuIds.push(item.skuList[0].id)
          })
          if (addSeriesCurrencySkuGroupVO.skuIds.length === 0) {
            this.$message.error('请选择关联SKU')
            return
          }
          skuGroupAddSeriesCurrency(addSeriesCurrencySkuGroupVO).then(res => {
            if (res.data.success) {
              this.$message.success('创建成功')
              this.$router.push('/productlist')
            }
          })
        } else {
          let skuVo = JSON.parse(JSON.stringify(this.skuVo))
          skuVo.simpleSkuSeriesVo.terminalSalePrice = skuVo.simpleSkuSeriesVo.salePrice
          skuVo.simpleSkuSeriesVo.terminalStepSalePrice = skuVo.simpleSkuSeriesVo.salePrice
          if (this.$route.query.showPoint == 'true') {
            skuVo.simpleSkuSeriesVo.onlineSalePrice = this.skuVo.simpleSkuSeriesVo.basePagePrice
          }
          skuGroupSeriesAdd(skuVo).then(res => {
            if (res.data.success) {
              this.$message.success('创建成功')
              this.$router.push('/productlist')
            }
          })
        }
      })
    },
    // 获得sku组下sku列表
    getSkuListBySkuGroupId () {
      skuList(this.skuList.skuGroup.id).then(res => {
        this.tableData = res.data.data.filter(item => {
          return !item.themeId
        })
      })
    },
    // 获取产品的SKU组详细信息
    getSpuMsg () {
      skuGroupListBySpuId({ pageNum: 1, pageSize: 1000, spuId: this.selectSpuId }).then(res => {
        if (res.data.success) {
          this.skuGroupListBySpuId = res.data.data.records.filter(item => {
            return item.onSale
          })
        }
      })
    },
    // 获取产品列表
    getSpuList (val) {
      if (val === null) {
        this.selectSpuId = ''
      }
      spuList({ pageNum: this.spuQueryInfo.pageNum, pageSize: this.spuQueryInfo.pageSize, spuVO: { categoryId: val, isSeries: 0, onSale: 1, spuProperty: this.$route.query.spuProperty } }).then(res => {
        if (res.data.success) {
          this.spuList = res.data.data.records
        }
      })
    },
    // 查看尺寸组
    checkSizeGroup (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.checkSizeGroupTableData = [res.data.data]
        }
      })
      this.sizeGroupDialog = true
    },
    // 删除主题
    deleteSampleTheme (scope) {
      this.skuVo.sampleThemeList.splice(scope.$index, 1)
      // this.skuTransferMsg.sampleTableData.splice(scope.$index, 1)
    },
    // 添加主题
    appendSampleTheme () {
      // 判断有没有选择
      if (this.skuTransferMsg.sampleItem === '') {
        this.$message.error('请选择')
        return
      }
      // 判断是否已经添加
      if (
        this.skuVo.sampleThemeList.some(item => {
          return item.id === this.skuTransferMsg.sampleItem.id
        })
      ) {
        this.$message.error('已经添加')
        return
      }
      this.skuVo.sampleThemeList.push({ sampleBarCode: '', sampleId: this.skuTransferMsg.sampleItem.id, ...this.skuTransferMsg.sampleItem, skuGroupSampleImageList: [] })
      // this.skuVo.sampleThemeIdSet.push(this.skuTransferMsg.sampleItem.id)
      // this.skuTransferMsg.sampleTableData.push(this.skuTransferMsg.sampleItem)
    },
    // 获取样品主题列表
    getSampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.skuTransferMsg.sampleList = res.data.data
        }
      })
    },
    fileSize (data) {
      let file = data.target.files[0]
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          if (width === height) {
            _this.upload(file)
          } else {
            _this.$message.error('图片长宽不相同')
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    // 上传样品文件
    upLoadTheme (id) {
      if (this.tagsList.length == 0) {
        this.$message.error('请选择sku')
        return
      }
      this.sampleThemeId = id
      this.upLoadSampleTheme = true
    },
    // 点击上传按钮
    async handleAddFolder (index, item) {
      // this.$nextTick(() => {
      //   // this.uploadImgsList = []
      //   this.$refs.handleUpload.$children[0].$refs.input.webkitdirectory = true
      // })
      console.log('item', item)
      let res = await composeGroupDetail(item.composeSizeGroupId)
      if (res.data.success) {
        this.defaultSizeGroup = res.data.data
      }
      this.coverPageNum = item.coverPage ? item.coverPage : 0
      this.maxPage = item.maxPage + this.coverPageNum
      this.minPage = item.basePage + this.coverPageNum
      this.fileInputIndex = index
      this.$refs.fileInput.click()
    },
    // 上传文件夹
    async handleFiles (event) {
      console.log('event', event.target.files)
      const files = []
      let filesList = []
      for (let key in event.target.files) {
        console.log('key', key)
        if (key !== 'length' && key !== 'item') {
          let file = event.target.files[key]
          filesList.push(file)
        }
      }
      filesList.forEach(a => {
        if (a.name.split('.').pop() != 'db') {
          files.push(a)
        }
      })
      // 过滤出隐藏文件
      if (files.length === 0) {
        return
      }
      let coverPageList = files.filter(a => a.name.includes('封面'))
      if (coverPageList.length !== this.coverPageNum) {
        this.$message.error('上传图片封面数量与当前sku的封面页数不一致')
        return
      }
      // 验证上传图片数量与实际需要上传数量是否一致
      if (this.maxPage == this.minPage) {
        if (files.length !== this.minPage) {
          this.$message.error('上传图片数量与当前sku的P数不一致')
          return
        }
      } else {
        if (files.length > this.maxPage) {
          this.$message.error('上传图片数量不能大于最大P数')
          return
        }
        if (files.length < this.minPage) {
          this.$message.error('上传图片数量不能小于最小P数')
          return
        }
      }
      files.sort(SortLikeWin)
      // 将封面排在最前面
      // let obj = {}
      // files.forEach((item, index) => {
      //   if (item.name.slice(0, item.name.lastIndexOf('.')) === '封面') {
      //     obj = item
      //     files.splice(index, 1)
      //     return true
      //   }
      // })
      // if (obj.name) {
      //   files.unshift(obj)
      // }
      let coverPage = files.filter(a => a.name.includes('封面'))
      let insidePage = files.filter(a => !a.name.includes('封面'))
      let filesNew = coverPage.concat(insidePage)
      console.log('filesNew', filesNew)
      this.loading = this.$loading({
        lock: true,
        text: '正在上传文件夹，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$set(this.tagsList[this.fileInputIndex], 'fileName', '')
      this.$set(this.tagsList[this.fileInputIndex], 'upLoadImgList', [])
      // 这里可以将文件上传到服务器
      this.imageAssemble(filesNew, 0)
    },
    imageAssemble (files, i) {
      let that = this
      ExifReader.load(files[i]).then(async (tags) => {
        console.log('tagsssss', tags)
        if (!tags.XResolution) {
          that.$message.error('您提交的图片不符合要求，请重新调整后再上传')
          that.loading.close()
          return
        }
        // 新增:为了解决读取出来的格式是3000000/10000
        if (tags.XResolution?.description.includes('/')) {
          tags.XResolution.description = that.convertToPixels(tags.XResolution.description)
          console.log('tags.XResolution.description', tags.XResolution.description)
        }
        if (tags.YResolution?.description.includes('/')) {
          tags.YResolution.description = that.convertToPixels(tags.YResolution.description)
          console.log('tags.YResolution.description', tags.YResolution.description)
        }
        let img = {
          width: tags['Image Width'].value,
          height: tags['Image Height'].value,
          xdpi: tags.XResolution?.description || 96,
          ydpi: tags.YResolution?.description || 96,
          // ColorSpace: tags['Color Space'] ? tags['Color Space'] : tags.ColorSpace
          color: tags['Color Components']?.description
        }
        // var pageTypeCodeName = files[i].name.includes('封面') ? 'COVER' : files.length == 1 ? 'SINGLE' : 'TEXT'
        var pageTypeCodeName = 'TEXT'
        if (that.tagsList[that.fileInputIndex].skuPageSettingList.length == 1) {
          pageTypeCodeName = that.tagsList[that.fileInputIndex].skuPageSettingList[0].skuPageType
        } else if (that.tagsList[that.fileInputIndex].skuPageSettingList.length == 2) {
          pageTypeCodeName = files[i].name.includes('封面') ? 'COVER' : 'TEXT'
        }
        let spuDpi = findCloseNum([254, 300], +img.xdpi)
        let error = that.checkPageSize(
          i,
          files,
          (img.width / spuDpi) * 25.4,
          (img.height / spuDpi) * 25.4,
          img.xdpi,
          img.ydpi,
          pageTypeCodeName,
          img.color,
          spuDpi
        )
        if (error) {
          that.loading.close()
          that.$message.error(error)
          return
        }
        console.log('上传图片++++++', i)
        await uploadWebImg(files[i], that.$store.state.awsSdk.product.s3).then(res => {
          console.log('resresresres', res)
          that.tagsList[that.fileInputIndex].upLoadImgList.push({
            sorting: i,
            url: res,
            imageName: files[i].name,
            pageTypeCode: pageTypeCodeName
          })
          i++
          // console.log('上传成功', that.upLoadImgList)
          if (i == files.length) {
            console.log('上传完成', files[0])
            that.loading.close()
            let fileName = files[0].webkitRelativePath.split('/')[0]
            that.$set(that.tagsList[that.fileInputIndex], 'fileName', fileName)
            console.log('that.tagsList', that.tagsList)
          } else {
            that.imageAssemble(files, i)
          }
          // this.fileName = data.file.name
        })
      })
    },
    // 校验图片
    checkPageSize (index, files, width, height, xdpi, ydpi, pageType, color, spuDpi) {
      console.log('this.defaultSizeGroup.sizeList', this.defaultSizeGroup.sizeList, pageType)
      // let oneName = files[0].name
      let coverPages = files.filter(a => a.name.includes('封面'))
      let sizeList = this.defaultSizeGroup.sizeList.find(a => a.pageTypeCode == pageType)
      console.log('sizeList', sizeList)
      let sizeHeightError = sizeList.sizeHeight < 100 ? 1 : Math.floor(sizeList.sizeHeight * 0.01)
      let sizeWidthError = sizeList.sizeWidth < 100 ? 1 : Math.floor(sizeList.sizeWidth * 0.01)
      // 宽高增加出血尺寸
      let newWidth = sizeList.sizeWidth + sizeList.bleed.bleedLeft + sizeList.bleed.bleedRight
      if (this.tagsList[this.fileInputIndex].specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版校验宽度(首页是封面的时候，校验第二P,首页不是封面的时候，校验第一P,最后一P,是不是传的一半的尺寸)
        width = width * 2
      }
      // 宽高增加出血尺寸
      let newHeight = sizeList.sizeHeight + sizeList.bleed.bleedTop + sizeList.bleed.bleedBottom
      console.log('宽高-----', width, newWidth)
      console.log('高宽++++', height, newHeight)
      // 宽宽，高高相同    宽高，高宽相同
      let w = Math.abs(width - newWidth)
      if (this.tagsList[this.fileInputIndex].specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版，由于宽度*了2，导致误差值翻倍，所以这里误差值要再/2
        w = w / 2
      }
      let h = Math.abs(height - newHeight)
      let wh = Math.abs(width - newHeight)
      let hw = Math.abs(height - newWidth)
      let w1 = sizeWidthError
      let h1 = sizeHeightError
      let error = ''
      if (!(color === '3' || color === 'RGB' || color === 'RGB with Alpha')) {
        error = '色彩模式应为RGB'
      } else if ((spuDpi === 300 && (+xdpi > 301 || +ydpi > 301)) || (spuDpi === 254 && (+xdpi < 253 || +ydpi < 253))) {
        error = '分辨率错误'
      } else if (Math.abs(width - newWidth) > sizeWidthError || Math.abs(height - newHeight) > sizeHeightError) {
        // this.selectList[userIndex].skus[item][index].error = (pageType === 'cover' ? '封面' : pageType === 'single' ? '单页' : '内页') + '尺寸错误'
        if (w > w1 && h < h1) {
          console.log('尺寸错误1')
          error = (pageType == 'COVER' ? '封面' : pageType == 'SINGLE' ? '单页' : '内页') + '尺寸错误'
        } else if (w < w1 && h > h1) {
          error = (pageType == 'COVER' ? '封面' : pageType == 'SINGLE' ? '单页' : '内页') + '尺寸错误'
        } else if (wh > h1 && hw > w1) {
          error = (pageType == 'COVER' ? '封面' : pageType == 'SINGLE' ? '单页' : '内页') + '尺寸错误'
        } else if (wh > h1 && hw < w1) {
          error = (pageType == 'COVER' ? '封面' : pageType == 'SINGLE' ? '单页' : '内页') + '尺寸错误'
        } else if (wh < h1 && hw > w1) {
          error = (pageType == 'COVER' ? '封面' : pageType == 'SINGLE' ? '单页' : '内页') + '尺寸错误'
        }
      }
      return error
    },
    // 确定上传
    async addThemeFile () {
      let haveNoFile = this.tagsList.filter(a => !a.upLoadImgList)
      if (haveNoFile.length) {
        this.$message.error('存在未上传文件的sku,请上传')
        return
      }
      let sampleSkuImageVOS = []
      this.tagsList.forEach(res => {
        let pageTypeVOS1 = res.upLoadImgList.filter(a => a.pageTypeCode == 'COVER') // 封面
        let pageTypeVOS2 = res.upLoadImgList.filter(a => {
          if (a.pageTypeCode == 'TEXT' || a.pageTypeCode == 'SINGLE') {
            return a
          }
        })
        let pageTypeVOS = []
        if (pageTypeVOS1.length > 0) {
          pageTypeVOS = [{
            imageUrlVOS: pageTypeVOS1.map(a => {
              return {
                sorting: a.sorting,
                url: a.url,
                name: a.imageName
              }
            }),
            pageTypeCode: pageTypeVOS1[0].pageTypeCode
          }, {
            imageUrlVOS: pageTypeVOS2.map((a, i) => {
              // return {
              //   sorting: a.sorting,
              //   url: a.url,
              //   name: a.imageName
              // }
              if (res.specialLayout && i == 0) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'LEFT'
                }
              } else if (res.specialLayout && i == (pageTypeVOS2.length - 1)) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'RIGHT'
                }
              } else {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName
                }
              }
            }),
            pageTypeCode: pageTypeVOS2[0].pageTypeCode
          }]
        } else {
          pageTypeVOS = [{
            imageUrlVOS: pageTypeVOS2.map((a, i) => {
              // return {
              //   sorting: a.sorting,
              //   url: a.url,
              //   name: a.imageName
              // }
              if (res.specialLayout && i == 0) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'LEFT'
                }
              } else if (res.specialLayout && i == (pageTypeVOS2.length - 1)) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'RIGHT'
                }
              } else {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName
                }
              }
            }),
            pageTypeCode: pageTypeVOS2[0].pageTypeCode
          }]
        }
        sampleSkuImageVOS.push({
          pageTypeVOS: pageTypeVOS,
          skuId: res.id
        })
      })
      let params = {
        sampleSkuImageVOS: sampleSkuImageVOS,
        skuGroupId: this.$route.query.id,
        themeId: this.sampleThemeId
      }
      let res = await saveSampleImage(params)
      console.log('res', res)
      if (res.data.success) {
        this.$message.success('上传成功')
        this.closeSampleTheme()
        this.skuTransferMsg.sampleTableData = this.skuTransferMsg.sampleTableData.map(a => {
          if (a.id == this.sampleThemeId) {
            return {
              ...a,
              isUploaded: true
            }
          } else {
            return a
          }
        })
        console.log('this.skuTransferMsg.sampleTableData', this.skuTransferMsg.sampleTableData)
      }
    },
    closeSampleTheme () {
      this.upLoadSampleTheme = false
      this.sampleThemeForm = {}
      this.upLoadImgList = []
    },
    // 预览样品图片
    async previewImg (id) {
      let val = {
        skuGroupId: this.$route.query.id,
        id: id
      }
      let res = await previewSampleImage(val)
      console.log('res', res)
      if (res.data.success) {
        this.imageList = []
        res.data.data.forEach(a => {
          a.pageTypeVOS.forEach(b => {
            // console.log('b.imageInfos', b.imageInfos)
            this.imageList = this.imageList.concat(b.imageInfos)
          })
        })
        // res.data.data[0].pageTypeVOS[0].imageInfos
        this.itemImgs.name = this.imageList[0].imageName
        this.itemImgs.index = 1
        this.imgViewerVisible = true
      }
    },
    // 轮播图切换
    carouselChange (i) {
      console.log('val', i)
      this.itemImgs.name = this.imageList[i].imageName
      this.itemImgs.index = i + 1
    },
    /* 预览轮播切换 */
    onClickCarousel (type) {
      if (type === 'prev') this.$refs['el-carousel'].prev()
      if (type === 'next') this.$refs['el-carousel'].next()
    },
    // 上传图片
    upload (file) {
      if (['image/png', 'image/jpg', 'image/jpeg', 'image/svg', 'image/svg+xml', 'image/webp'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的图片格式')
        return false
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.skuVo.skuGroupImage = res
      })
    },
    // --------------------------------------------------------------
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    handNodeClick (data, node, nodeData) {
      // if (node.childNodes.length === 0) {
      this.treeDataValue = data
      this.skuList.proType = data.label
      this.$refs.multiSelect.blur()
      // }
    },
    clearHandle () {
    },
    handleClose (val, index) {
      this.tableData[val.index].operation = '添加'
      this.tags.splice(index, 1)
    },
    RowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 删除sku组
    deleteSKUGroup (index) {
      this.tags.splice(index, 1)
      this.tagsList.splice(index, 1)
      this.skuVo.simpleSkuSeriesVo.skuIdSet = this.tags.map(a => { return a.id })
    },
    // 添加sku组
    addSKUGroup (val) {
      // 校验重复
      let lock = false
      this.tags.forEach(item => {
        if (item.id === val.id) {
          lock = true
        }
      })
      if (lock) {
        this.$message.error('已经添加该sku')
        return
      }
      this.tags.push(val)
      this.tagsList.push(val) // 上传样品图片时候用到
      this.skuVo.simpleSkuSeriesVo.skuIdSet = this.tags.map(a => { return a.id })
      // this.skuVo.simpleSkuSeriesVo.skuIdSet.push(val.id)
      this.$refs.addForm.validateField('skuGroupTags')
    },
    returnPage () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' })
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
